type DialogFooterProps = {
  children: React.ReactNode;
  className?: string;
};
export function DialogFooter({ children, className = "" }: DialogFooterProps) {
  return (
    <div
      className={`flex justify-end px-6 py-3  sticky bottom-0 shadow-inner ${className}`}
    >
      {children}
    </div>
  );
}
